// config/github.js
// Configuration module for managing GitHub repository settings in StackTrack backend

const GITHUB_ORG = process.env.GITHUB_ORG || "stacktrack-org";
const DEFAULT_BRANCH = "main";
const SUBMISSION_BRANCH = "main"; 
const REPO_PREFIX = "stacktrack";
const USE_GITHUB_CLASSROOM = process.env.USE_GITHUB_CLASSROOM === "true" ? true : false;
const GITHUB_TOKEN = process.env.GITHUB_TOKEN;

function generateRepoName(labId, registerNo) {
  return `${REPO_PREFIX}-${labId}-${registerNo}`;
}

function generateRepoUrl(labId, registerNo) {
  return `https://github.com/${GITHUB_ORG}/${generateRepoName(labId, registerNo)}`;
}

module.exports = {
  GITHUB_ORG,
  DEFAULT_BRANCH,
  SUBMISSION_BRANCH,
  REPO_PREFIX,
  USE_GITHUB_CLASSROOM,
  GITHUB_TOKEN,
  generateRepoName,
  generateRepoUrl,
};
